"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_type_1 = require("./is-type");
exports.default = (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        is_type_1.default(value, 'Array');
});
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.9@@antv/util/lib/is-array.js
// module id = dRdi
// module chunks = 14